import React, { useState, useEffect, useRef, useContext } from 'react';

import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast'


import Loader from '../../../Base/Components/Loader/Loader';
import { AuthContext } from '../../../Base/Context/AuthContext/AuthContext';
import { getAreasAct } from '../../../Base/API/Global/Areas/AreasRequests';
import DividirItemArea from '../../../Base/Components/DividirItemsArea/DividirItemArea';
import { getCuentasAreaTotales } from '../../../API/Finanzas/CuentasAreas/cuentasAreasReques';
import { getCuentasHijas } from '../../../API/Finanzas/Retencion/ConceptoRetencionRequest';
import { toastShow } from '../../../Base/Services/ToastService';
import { ajusteDiferencialRedondeoJson } from '../../../utils/Funciones/AjusteDiferencialRedondeo';




const ModalDividirDetalles = ({ dialogDividir, hideDividir, selectedDet, detalles, setDetalles ,values }) => {

  const toast = useRef(null)
  const [loading, setLoading] = useState(false);
  const [selectedAreas, setSelectedAreas] = useState(null);
  const [areas, setAreas] = useState([]);
  const { userAuth } = useContext(AuthContext);
  const [habilitar, setHabilitar] = useState(false);
  const [cuentasAreas, setCuentasAreas] = useState([]);
  const [det, setDet] = useState({});
  const [details, setDetails] = useState([]);
  const [cuentas, setCuentas] = useState([]);
  const [IsDetallesEspecial, setIsDetallesEspecial] = useState(false)

  const obtenerInformacion = async (v) => {
    setLoading(true)
    const tempoAreas = await getAreasAct()
    setAreas(tempoAreas)

    const tempoCuentas = await getCuentasAreaTotales()
    setCuentasAreas(tempoCuentas)

    const tempoCuentasH = await getCuentasHijas()
    setCuentas(tempoCuentasH.map((c) => {
      return {
        IdCuentaFinanzas: c.IdAccount,
        Account: c.Account,
        CuentaFinanzas: c.Cuenta,
        CodigoAccount: c.CodigoAccount,
        IdContenedorAccount: c.IdContenedorAccount,
        IdSubCategoria: c.IdSubCategoria,
        CuentaFinanzas: c.NombreCuenta,
        Type: c.Type,
        cca: c.cca,
        codeS: c.codeS,
      }
    }));

    setDetails(detalles)
    // let De = detallesEspeciales()

    // if (De) {
    //     const tempo = await getDetallesIngresosDivididos(detalles[0]?.IdDetalle)

    //     if (tempo) {
    //         if (tempo?.valido) {
    //             if (tempo?.data?.length > 0) {
    //                 let detallesTelefonia = tempo?.data?.find((d) => d.IdProducto === 27887)
    //                 let detallesSeguro = tempo?.data?.find((d) => d.IdProducto === 24966 || d.IdProducto === 24967)
    //                 if (detallesTelefonia || detallesSeguro) {
    //                     CrearNuevosDetalles(tempo?.data)
    //                 } else {
    //                     let sinArea = tempo?.data.find((t) => t.IdArea === null && t.IdProducto === 27555)
    //                     let sinAreaListado = tempo?.data.filter((t) => t.IdArea === null && t.IdProducto === 27555)

    //                     if (sinArea) {
    //                         toast.current.show({
    //                             severity: 'error',
    //                             summary: 'Personal sin area:',
    //                             // sticky: true,
    //                             life: 10000,
    //                             content: (props) => (
    //                                 <div className="flex flex-column align-items-left" style={{ flex: '1' }}>
    //                                     <div className="flex align-items-center gap-2">
    //                                         <span style={{ fontSize: 14, fontWeight: 'bold' }}>Personal sin area: <br /></span>
    //                                         {
    //                                             sinAreaListado?.map((d) => {
    //                                                 if (!d.IsExterno) {
    //                                                     return d?.NombreEmpleado?.split(', ').map((nombre, index) => (
    //                                                         <div key={index} style={{ fontSize: 13 }}>
    //                                                             - {nombre}
    //                                                         </div>
    //                                                     ))

    //                                                 } else {
    //                                                     return d?.NombreEmpleado?.split(', ').map((nombre, index) => (
    //                                                         <div key={index} style={{ fontSize: 13 }}>
    //                                                             - {nombre} / Externo
    //                                                         </div>
    //                                                     ))
    //                                                 }
    //                                             })
    //                                         }


    //                                     </div>
    //                                 </div>
    //                             )
    //                         });
    //                     } else {
    //                         setSelectedAreas(tempo?.data)
    //                     }
    //                 }


    //             }
    //         }
    //     }
    // }

    // otrosDetallesEspeciales()

    setLoading(false)
  }

  const CrearDivision = () => {
    setLoading(true)
    let detalleNuevo = []
    let finalizo = false


    details.map((d) => {
      selectedAreas.map(function callback(a, index) {
        let CA
        if (!a?.IdCuenta) {
          CA = cuentasAreas.find((c) => (c.IdArea === a.IdArea || (c.IdClasificacion === a.IdClasificacion)) && (c.IdSubCategoria === d.IdSubCategoriaFinanzas) && (c.IdMO === null || c.IdMO === a.IdMO))
        } else {
          CA = cuentas.find((c) => c.IdCuentaFinanzas === a?.IdCuenta)
        }

        let memoD = ''
        switch (d.IdSubCategoria) {
          case 110:
            memoD = 'Consumo de agua embotellada para ' + a.CantidadArea + ' empleados de ' + a?.ManoObra + ' del depto ' + a.Area
            break;
          default:
            memoD = 'Compra de ' + d.Cantidad + ' ' + d.NombreProducto
            break;
        }

        if (index === 0) {
          detalleNuevo.push({
            ...d,
            Cantidad: d.Cantidad * a.ProporcionArea,
            MontoL: d.MontoL * a.ProporcionArea,
            MontoD: d.MontoD * a.ProporcionArea,
            CostoL: d.CostoL * a.ProporcionArea,
            CostoD: d.CostoD * a.ProporcionArea,
            ISVD: d.ISVD * a.ProporcionArea,
            ISVL: d.ISVL * a.ProporcionArea,
            DescuentoL: d.DescuentoL * a.ProporcionArea,
            DescuentoD: d.DescuentoD * a.ProporcionArea,

            IdUserEdit: userAuth.IdUser,
            IdArea: a.IdArea,
            Area: a.Area,
            IdCuentaFinanzas: CA?.IdCuentaFinanzas ? CA?.IdCuentaFinanzas : null,
            CuentaFinanzas: CA?.CuentaFinanzas ? CA?.CuentaFinanzas : null,
            IdCuentaAlgodon: CA?.IdCuentaAlgodon ? CA?.IdCuentaAlgodon : null,
            CuentaAlgodon: CA?.CuentaAlgodon ? CA?.CuentaAlgodon : null,
            IdCuentaSintetico: CA?.IdCuentaSintetico ? CA?.IdCuentaSintetico : null,
            CuentaSintetico: CA?.CuentaSintetico ? CA?.CuentaSintetico : null,
            IsDobleCuenta: CA?.IsDobleCuenta ? CA?.IsDobleCuenta : null,
            MemoDet: a?.MemoDet ? a?.MemoDet : memoD
          })
        } else {
          let CantidadNuevo = d.Cantidad * a.ProporcionArea
          let IdDetAleatorio = -(detalles?.length + 1 + detalleNuevo?.length + 2)
          let idExiste = detalles.some((s) => s.IdIngresoDetalle === IdDetAleatorio)
          detalleNuevo.push({
            ...d,
            IdIngresoDetalle: idExiste ? IdDetAleatorio * 3 : IdDetAleatorio,
            Cantidad: CantidadNuevo,
            MontoL: d.MontoL * a.ProporcionArea,
            MontoD: d.MontoD * a.ProporcionArea,
            CostoL: d.CostoL * a.ProporcionArea,
            CostoD: d.CostoD * a.ProporcionArea,
            ISVD: d.ISVD * a.ProporcionArea,
            ISVL: d.ISVL * a.ProporcionArea,
            DescuentoL: d.DescuentoL * a.ProporcionArea,
            DescuentoD: d.DescuentoD * a.ProporcionArea,
            IdDetalleOriginal: det.IdIngresoDetalle > 0 ? det.IdIngresoDetalle : null,
            IdUserEdit: userAuth?.IdUser,
            IdArea: a.IdArea,
            Area: a.Area,
            IdCuentaFinanzas: CA?.IdCuentaFinanzas ? CA?.IdCuentaFinanzas : null,
            CuentaFinanzas: CA?.CuentaFinanzas ? CA?.CuentaFinanzas : null,
            IdCuentaAlgodon: CA?.IdCuentaAlgodon ? CA?.IdCuentaAlgodon : null,
            CuentaAlgodon: CA?.CuentaAlgodon ? CA?.CuentaAlgodon : null,
            IdCuentaSintetico: CA?.IdCuentaSintetico ? CA?.IdCuentaSintetico : null,
            CuentaSintetico: CA?.CuentaSintetico ? CA?.CuentaSintetico : null,
            IsDobleCuenta: CA?.IsDobleCuenta ? CA?.IsDobleCuenta : null,
            MemoDet: a?.MemoDet ? a?.MemoDet : memoD

          })
        }

        if (index === selectedAreas?.length - 1) {
          finalizo = true
        }
      });
    })

    let detallesFinal = []
    let fields = ['MontoL', 'MontoD', 'CostoL', 'CostoD', 'Cantidad']
    let detalleEnergia = detalles.find((d) => d.IdProducto === 25887)
    if (detalleEnergia) {
      fields = ['MontoL', 'MontoD', 'CostoL', 'CostoD']
    }
    detalles.forEach((dn) => {
      let detS = detalleNuevo?.filter((d) => d.IdPurchaseOrderDetail === dn.IdPurchaseOrderDetail)
      fields.forEach((f) => {
        let valor = ajusteDiferencialRedondeoJson(
          dn[f],
          [
            ...detS
          ],
          f
        )
        detS = valor
      });

      detallesFinal.push(...detS)
    });
    let tempoDet = detalles?.filter(detail => !detallesFinal.some((n) => n.IdIngresoDetalle === detail.IdIngresoDetalle))
    let nuevoArreglo = tempoDet.concat(...detallesFinal)
    setDetalles(nuevoArreglo)
    toastShow(toast, 'success', 'Distribución creada', 'Se dividio de manera correcta la salida');
    setSelectedAreas(null)
    setHabilitar(true)
    setLoading(false)
  }



  useEffect(() => {
    if (dialogDividir) {
      obtenerInformacion()
    } else {
      setHabilitar(false)
      setSelectedAreas(null)
      setIsDetallesEspecial(false)
    }
  }, [dialogDividir])


  return (
    <Dialog
      visible={dialogDividir}
      onHide={hideDividir}
      style={{ width: "65vw", height: "65vh" }}
      closeOnEscape={false}
    >
      <Toast ref={toast} />
      <Loader loading={loading} querySelector={"#DividirDetallesCXP"} />
      <div className="d-flex flex-row">
        <DividirItemArea
          detalles={selectedDet}
          CantidadDetalle={selectedDet[0]?.CantidadReservada}
          selectedAreas={selectedAreas}
          setSelectedAreas={setSelectedAreas}
          setHabilitar={setHabilitar}
          IdSubCategoria={selectedDet[0]?.IdSubCategoria}
        />
        <Button
          onClick={() => CrearDivision()}
          disabled={selectedAreas?.length && !habilitar ? false : true}
          icon="ri-check-double-line"
          className="mx-2"
          style={{ width: 50, height: 40 }}
        />
      </div>
    </Dialog>
  );
}

export default ModalDividirDetalles
